import { Box, Button, Stack } from '@mui/material';
import tokens from '@verifime/design-tokens';
import ActionsButton from '../ActionsButton';
import { ColoredIcon } from '../ColoredIconAndChip';
import type { TActions } from '../ActionsButton';
import { TDocumentVerificationStatusActions } from './types';

/**
 * Component for DVS status action buttons
 */
export const DvsStatusActions = ({
  onResetStatus,
  onResubmit,
  resubmitDisabled,
}: Readonly<{
  onResetStatus: (status: keyof TDocumentVerificationStatusActions) => void;
  onResubmit: () => void;
  resubmitDisabled: boolean;
}>) => {
  // Create a properly typed actions mapping
  const actionsMapping: TActions<string> = {
    Passed: {
      iconName: 'checkCircleRounded',
      colorName: 'successMain',
      onActionClick: () => onResetStatus('Passed'),
    },
    Failed: {
      iconName: 'errorRounded',
      colorName: 'errorMain',
      onActionClick: () => onResetStatus('Failed'),
    },
    DataError: {
      iconName: 'errorRounded',
      colorName: 'errorMain',
      onActionClick: () => onResetStatus('DataError'),
    },
  };

  return (
    <Stack gap={tokens.spacingXs} justifyContent="center" alignItems="center">
      <Box>
        <Button
          startIcon={<ColoredIcon iconName="pending" />}
          variant="outlined"
          onClick={onResubmit}
          disabled={resubmitDisabled}
        >
          Re Submit
        </Button>
      </Box>
      <ActionsButton
        startIcon={<ColoredIcon iconName="pending" />}
        variant="outlined"
        buttonName="Set Status"
        actions={actionsMapping}
      />
    </Stack>
  );
};
